/* hx-ingredients.js — search, benefit chips and the read-more dialog on the
   ingredients page.

   Loaded for the whole site from layout/theme.liquid rather than from the
   section, and every listener is delegated from the document: a section's own
   <script> does not run again when the theme editor re-renders it, and this is
   a page that is nothing but behaviour. It no-ops everywhere the grid is absent.

   Filtering is two independent tests joined by AND: the typed query against the
   card's text, and the chosen benefit chips against the groups the card falls
   into. Chips OR among themselves — pick energy and focus and you get both. */
(function () {
  var state = { q: '', groups: [] };
  var grid = null;
  var cards = [];

  /* Lowercased, punctuation flattened, so a search for "carnitine" finds
     "L-Carnitine L-Tartrate" and "vitamin b7" finds "Biotin (Vitamin B7)". */
  function flat(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function groupDefs() {
    var tag = document.querySelector('[data-ing-groups]');
    if (!tag) return [];
    try {
      return JSON.parse(tag.textContent).map(function (g) {
        return {
          slug: g.slug,
          words: String(g.keywords || '').split(',').map(function (w) { return flat(w); }).filter(Boolean)
        };
      });
    } catch (e) { return []; }
  }

  /* Read the cards once: their haystack and which groups they belong to never
     change, and doing it per keystroke across 186 cards is wasted work. */
  function index() {
    grid = document.querySelector('[data-ing-grid]');
    if (!grid) { cards = []; return; }
    var defs = groupDefs();
    cards = [].slice.call(grid.querySelectorAll('[data-ing-card]')).map(function (el) {
      var hay = flat(el.dataset.name + ' ' + (el.dataset.bens || '') + ' ' + (el.dataset.desc || ''));
      var groups = defs.filter(function (g) {
        return g.words.some(function (w) { return hay.indexOf(w) !== -1; });
      }).map(function (g) { return g.slug; });
      el.dataset.groups = groups.join(' ');
      return { el: el, hay: hay, groups: groups };
    });
  }

  function apply() {
    if (!cards.length) return;
    var shown = 0;
    cards.forEach(function (c) {
      var hit = (!state.q || c.hay.indexOf(state.q) !== -1) &&
        (!state.groups.length || state.groups.some(function (g) { return c.groups.indexOf(g) !== -1; }));
      c.el.hidden = !hit;
      if (hit) shown++;
    });

    var empty = document.querySelector('[data-ing-empty]');
    if (empty) empty.hidden = shown !== 0;

    var count = document.querySelector('[data-ing-count]');
    if (count) {
      /* the noun agrees with the total, which is what it is attached to:
         "1 of 12 ingredients", not "1 of 12 ingredient" */
      var noun = cards.length === 1 ? ' ingredient' : ' ingredients';
      count.textContent = (state.q || state.groups.length)
        ? shown + ' of ' + cards.length + noun
        : cards.length + noun;
    }
  }

  /* search */
  document.addEventListener('input', function (e) {
    var input = e.target.closest ? e.target.closest('[data-ing-input]') : null;
    if (!input) return;
    if (!cards.length) index();
    state.q = flat(input.value);
    input.closest('.fsearch').classList.toggle('has', input.value !== '');
    apply();
  });

  document.addEventListener('click', function (e) {
    var clear = e.target.closest('[data-ing-clear]');
    if (clear) {
      var input = document.querySelector('[data-ing-input]');
      if (input) { input.value = ''; input.focus(); }
      clear.closest('.fsearch').classList.remove('has');
      state.q = '';
      apply();
      return;
    }

    /* chips — "All" is the empty slug, and picking it clears the rest */
    var chip = e.target.closest('[data-ing-group]');
    if (chip) {
      if (!cards.length) index();
      var slug = chip.dataset.ingGroup;
      if (!slug) {
        state.groups = [];
      } else {
        var at = state.groups.indexOf(slug);
        if (at === -1) state.groups.push(slug); else state.groups.splice(at, 1);
      }
      [].forEach.call(document.querySelectorAll('[data-ing-group]'), function (b) {
        var on = b.dataset.ingGroup ? state.groups.indexOf(b.dataset.ingGroup) !== -1 : state.groups.length === 0;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply();
      return;
    }

    var card = e.target.closest('[data-ing-card]');
    if (card) { open(card); return; }

    if (e.target.closest('[data-ing-close]')) {
      var dlg = document.querySelector('[data-ing-dialog]');
      if (dlg && dlg.open) dlg.close();
    }
  });

  function open(card) {
    var dlg = document.querySelector('[data-ing-dialog]');
    if (!dlg) return;
    var set = function (sel, text) { var el = dlg.querySelector(sel); if (el) el.textContent = text || ''; };

    set('[data-ing-dlg-title]', card.dataset.name);
    set('[data-ing-dlg-desc]', card.dataset.desc);

    var img = dlg.querySelector('[data-ing-dlg-img]');
    if (img) {
      if (card.dataset.img) { img.src = card.dataset.img; img.hidden = false; }
      else { img.removeAttribute('src'); img.hidden = true; }
    }

    /* the benefit lines are stored joined with a middle dot, which is how they
       read on one line and how they split into a list here */
    var list = dlg.querySelector('[data-ing-dlg-bens]');
    if (list) {
      var bens = (card.dataset.bens || '').split('·').map(function (b) { return b.trim(); }).filter(Boolean);
      list.textContent = '';
      bens.forEach(function (b) { var li = document.createElement('li'); li.textContent = b; list.appendChild(li); });
      list.hidden = bens.length === 0;
    }

    var link = dlg.querySelector('[data-ing-dlg-link]');
    if (link) {
      if (card.dataset.url) { link.href = card.dataset.url; link.hidden = false; }
      else { link.removeAttribute('href'); link.hidden = true; }
    }

    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }

  /* the backdrop is part of the dialog element, so a click that lands on the
     dialog itself rather than on anything inside it is a click outside */
  document.addEventListener('click', function (e) {
    var dlg = e.target.closest ? e.target.closest('[data-ing-dialog]') : null;
    if (!dlg || !dlg.open) return;
    var box = dlg.getBoundingClientRect();
    var inside = e.clientX >= box.left && e.clientX <= box.right && e.clientY >= box.top && e.clientY <= box.bottom;
    if (!inside) dlg.close();
  });

  function start() { index(); apply(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
